import React from 'react';

const Footer = () => <muse-footer />;

export default Footer;
